export default __webpack_public_path__ + "static/media/hero.359e9125.png";